import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import DomainReport from "./pages/DomainReport";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import CyberRiskReport from "./pages/CyberRiskReport";
import TermsOfService from "./components/TermsOfService";
import NetworkStatus from "./components/NetworkStatus";
import ProtectedRoute from "./helper/ProtectedRoute";
import Dashboard from "./admin/pages/Dashboard";
import Sidebar from "./admin/components/Sidebar";
import Header from "./admin/components/Header";
import Login from "./admin/pages/Login";
import "./admin/styles/App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Revenue from "./admin/pages/Revenue/Revenue";
import { useSelector } from "react-redux";
import NotFound from "./components/NotFound/NotFound";
import AdminLayout from "./components/Layout/AdminLayout";
import OEMPartners from "./admin/pages/OEMPartners/OEMPartners";
import AlmataPartner from "./admin/pages/AlmataPartners/AlmataPartner";
import Transaction from "./admin/pages/Transaction/Transaction";
import MyScan from "./admin/pages/Scan/MyScan";
import OemScan from "./admin/pages/OEMScan/OemScan";
import AllCoupon from "./admin/pages/Coupon/AllCoupon";
import Profile from "./admin/pages/Profile/Profile";
import EmailVerification from "./admin/pages/EmailVerification/EmailVerification";
import ItSalesPartners from "./admin/pages/ItSales/ItSalesPartners";
import Setting from "./admin/pages/Settings/Setting";
import AlmataOemDetails from "./admin/pages/AlmataPartners/AlmataOemDetails";
import AlmataEndUserOfOem from "./admin/pages/AlmataPartners/AlmataEndUserOfOem";
import ItOemDetails from "./admin/pages/ItSales/ItOemDetails";
import ItEndUserOfOem from "./admin/pages/ItSales/ItEndUserOfOem";
import ResetPassword from "./admin/pages/ResetPassword";
import { IoGameController } from "react-icons/io5";
import ItSalesSplitView from "./admin/pages/ItSales/ItSalesSplitView";
import AlmataSplitView from "./admin/pages/AlmataPartners/AlmataSplitView";

const LoginRoute = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const token = sessionStorage.getItem("authToken");
  if (isAuthenticated || token) {
    return <Navigate to="/" replace />;
  }

  return <Login />;
};

const ResetPasswordRoute = () => {
  const handleBackToLogin = () => {
    window.location.href = "/login";
  };
  return <ResetPassword onBackToLogin={handleBackToLogin} />;
};

function App() {
  return (
    <Router
    // basename={process.env.ADMINURL || "/admin"}
    >
      <NetworkStatus />
      <Routes>
        {/* Public Routes - No Authentication Required */}
        <Route path="/cyberRiskReport" element={<CyberRiskReport />} />
        <Route
          path="/cyberRiskReport/verify-mail/:token/:email"
          element={<CyberRiskReport />}
        />
        <Route path="/domain-scan-result/:userId" element={<DomainReport />} />
        <Route path="/domain-report" element={<DomainReport />} />
        <Route path="/termsofservice" element={<TermsOfService />} />

        {/* Login Route */}
        <Route path="/login" element={<LoginRoute />} />
        <Route path="/reset-password" element={<ResetPasswordRoute />} />

        {/* Email Verification Routes */}
        <Route
          path="/verify-email/:token/:email"
          element={<EmailVerification />}
        />
        <Route path="/admin/verify" element={<EmailVerification />} />

        {/* Protected Admin Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="oem-partners" element={<OEMPartners />} />
          <Route path="almata-partners" element={<AlmataPartner />} />
          <Route path="almataOemPartner" element={<AlmataOemDetails />} />
          <Route path="almataEndUserOfOem" element={<AlmataEndUserOfOem />} />
          <Route path="almata-oem-end-users" element={<AlmataSplitView />} />
          <Route path="revenue" element={<Revenue />} />
          <Route path="transactions" element={<Transaction />} />
          <Route path="scan" element={<MyScan />} />
          <Route path="OEMScan" element={<OemScan />} />
          <Route path="all-coupons" element={<AllCoupon />} />
          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<Setting />} />
          <Route path="itsales-Partner" element={<ItSalesPartners />} />
          <Route path="itoemdetails" element={<ItOemDetails />} />
          <Route path="it-end-user-of-oem" element={<ItEndUserOfOem />} />
          <Route path="itsales-split-view" element={<ItSalesSplitView />} />
        </Route>

        {/* 404 Not Found Route - Outside of protected layout */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Router>
  );
}

export default App;
